import { assertNever } from '@gitbook/util-ts';

import type { KeyedListDiff } from './diffKeyedLists';

/**
 * Apply the diff to transform a `before` keyed list into the `after`.
 */
export function applyKeyedListDiff<BeforeValue, AfterValue>(
    diffs: KeyedListDiff<BeforeValue, AfterValue>[],
    strategy: {
        insert: (at: number, items: AfterValue[]) => void;
        delete: (at: number, length: number) => void;
        update: (at: number, before: BeforeValue, after: AfterValue) => void;
    }
) {
    let index = 0;
    diffs.forEach((diff) => {
        switch (diff.op) {
            case '+': {
                strategy.insert(index, diff.values);
                index += diff.values.length;
                break;
            }
            case '-': {
                strategy.delete(index, diff.values.length);
                break;
            }
            case '=': {
                index += diff.values.length;
                break;
            }
            case '~': {
                strategy.update(index, diff.before, diff.after);
                index += 1;
                break;
            }
            default:
                assertNever(diff);
        }
    });
}
